import React, { useEffect } from 'react';
import { Empty } from 'antd';
import Profiles from './Profiles';
import styles from './index.module.less';
import profilePhoto from './images/Simplification.png';

export default function ProfileData({ list_data, onProfileAction }) {
  // console.log('list_data', list_data);

  useEffect(() => {}, [list_data]);

  // Map list_data to match the expected keys for Profiles
  const transformedData = list_data?.flatMap((item) => {
    return item.Profiles.map((profile) => ({
      pic:
        profile.ProfileImages.length > 0
          ? profile.ProfileImages[0].objectKey
          : profilePhoto,
      // code: item.user_name || '',
      code: item?.profile_unique_id || '',
      name: profile?.profile_name || '',
      dob: profile?.calculated_age ? `${profile?.calculated_age} yrs` : '',
      // height: `${profile.height_ft || ''}' ${profile.height_in || ''}"`,
      height: profile?.height_cms ? `${profile.height_cms} cm` : '',
      marriedStatus: profile?.MaritalStatus?.marital_status, // Add if available in your data
      address: profile.City?.city || '',
      occupation: profile.employed_in || '',
      education:
        profile.ProfileEducations.map(
          (edu) => edu.HigherEducation.education
        ).join(', ') || '',
      // income: profile.annual_income || '',
      income: profile.annual_income
        ? Number(profile.annual_income).toLocaleString()
        : '',
      isNew: item?.is_new, // Assuming a default value
      isFavourite: profile.is_favourite, // Assuming a default value
      id: item.id,
      profile_id: profile.id
    }));
  });

  // console.log('transformedData', transformedData);
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%'
      }}
    >
      <div
        style={{
          paddingTop: '15px',
          paddingBottom: '30px'
        }}
      >
        {transformedData?.length > 0 ? (
          <div className={styles.profilegrid}>
            {transformedData?.map((partner, index) => (
              <Profiles
                key={partner.code || index}
                data={partner}
                onProfileAction={onProfileAction}
              />
            ))}
          </div>
        ) : (
          <Empty
            description="No profiles available"
            className={styles.emptydashboard}
          />
        )}
      </div>
    </div>
  );
}
